import formatNumber from "../../../../../utils/formatNumber";
import Style from "./index.module.css";
const ProjectPartnersExpensesList = ({ partnersList }) => {
  return (
    <ul className={Style.PartnerExpenseList}>
      {partnersList.map((partner, index) => (
        <li key={index}>
          <span>
            {partner.name} {formatNumber(partner.budget)} EUR
          </span>
        </li>
      ))}
    </ul>
  );
};

export default ProjectPartnersExpensesList;
